var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-base-db",attrs:{"id":"app-base-db"}},[_c('div',{staticClass:"dlaheader"},[_c('div',{staticClass:"dlatitle"},[_vm._v(_vm._s(_vm.dlaname))]),_c('div',{staticClass:"black-close",on:{"click":function($event){return _vm.mindla()}}})]),_c('div',{staticClass:"dlabody",domProps:{"innerHTML":_vm._s(_vm.dlacontent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }